var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProductsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.5,
    r: 65.5,
    fill: "url(#paint0_linear_2487_54855)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2487_54855)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.755 94.4L74.413 59.2929V40.3542L80.5443 32.6788C81.7251 31.18 80.6805 29 78.773 29H51.8864C49.9789 29 48.9343 31.18 50.1151 32.6788L56.2464 40.3542V59.2929L29.9047 94.4C27.6793 97.3975 29.8139 101.667 33.538 101.667H97.1214C100.846 101.667 102.98 97.3975 100.755 94.4ZM76.8295 76.833C76.8295 80.1467 74.1432 82.833 70.8295 82.833C67.5158 82.833 64.8295 80.1467 64.8295 76.833C64.8295 73.5193 67.5158 70.833 70.8295 70.833C74.1432 70.833 76.8295 73.5193 76.8295 76.833ZM53 91C55.2091 91 57 89.2091 57 87C57 84.7909 55.2091 83 53 83C50.7909 83 49 84.7909 49 87C49 89.2091 50.7909 91 53 91Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2487_54855",
    x1: 156,
    y1: 57.5,
    x2: -20.066,
    y2: 9.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0709463,
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206883,
    stopColor: "#030972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409043,
    stopColor: "#654EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565147,
    stopColor: "#88B04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698233,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841555,
    stopColor: "#EB6E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979796,
    stopColor: "#EB6E23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2487_54855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProductsIcon);
export default __webpack_public_path__ + "static/media/noProductsIcon.d9070e20c8698240332af5c44985ff53.svg";
export { ForwardRef as ReactComponent };